export const SUPPORTED_LOCALES = ['en', 'fr', 'de', 'es', 'it', 'nl'] as const;

export type EasyshipLocale = (typeof SUPPORTED_LOCALES)[number];
